/*
  Recommandations produit (MH · Slider produits, source « Recommandations automatiques »).
  Shopify ne fournit les recommandations que via routes.product_recommendations_url :
  on recharge la section avec ce point d'accès puis on remplace son contenu.
  Sans recommandation, la section est masquée.
  Le produit déjà proposé par le bloc « Cross-sell » (assets/mh-cross-sell.js) est retiré du carrousel.
*/
(function () {
  function removeCrossSell(section, productId) {
    if (!productId) return;
    section.querySelectorAll(`.mh-card-product[data-product-id="${productId}"]`).forEach((card) => {
      (card.closest('.mh-product-slider__item') || card).remove();
    });
  }

  document.addEventListener('mh:cross-sell', (event) => {
    document.querySelectorAll('[data-mh-recommendations-url]').forEach((section) => {
      removeCrossSell(section, event.detail.productId);
    });
  });

  function load(section) {
    const url = section.dataset.mhRecommendationsUrl;
    if (!url || section.dataset.mhRecommendationsLoaded) return;
    section.dataset.mhRecommendationsLoaded = 'true';

    fetch(url)
      .then((response) => response.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('.mh-product-slider');
        if (!fresh || !fresh.querySelector('.mh-card-product')) {
          section.closest('.shopify-section')?.setAttribute('hidden', '');
          section.hidden = true;
          return;
        }
        section.innerHTML = fresh.innerHTML;
        removeCrossSell(section, window.mhCrossSellProductId);
      })
      .catch(() => {
        section.hidden = true;
      });
  }

  function init() {
    document.querySelectorAll('[data-mh-recommendations-url]').forEach((section) => {
      if (!('IntersectionObserver' in window)) return load(section);
      const observer = new IntersectionObserver((entries) => {
        if (!entries[0].isIntersecting) return;
        observer.disconnect();
        load(section);
      }, { rootMargin: '0px 0px 400px 0px' });
      observer.observe(section);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
